import LandingPage from "../features/Landing/components/Landing";

export default LandingPage;
